require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.6f6e4f96.js\",\"4ubsC\":\"icon.bf742675.svg\",\"jo4oI\":\"index.a72aed83.css\"}"));